exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".salemanage-entrance{padding:0 .4rem;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.salemanage-entrance .salemanage-entrance-cell{padding:.66666667rem .4rem}.salemanage-entrance .salemanage-entrance-cell .sale-img{display:block;width:1.33333333rem;height:1.33333333rem;margin-right:.4rem;border-radius:50%}", ""]);

// exports
